import { render, staticRenderFns } from "./MailImportRegistryFormPage.vue?vue&type=template&id=d4e0d724&scoped=true&"
import script from "./MailImportRegistryFormPage.vue?vue&type=script&lang=js&"
export * from "./MailImportRegistryFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e0d724",
  null
  
)

export default component.exports